import { ProducedFromType } from './types';

export const producedFromTypes: ProducedFromType[] = [
  { type: 'name', title: 'Name' },
  { type: 'barcodeupc', title: 'Barcode/UPC' },
  { type: 'sku', title: 'SKU' },
];
